import type { Tokens } from '../../../theming/types'
import type { RadioButtonProps } from '..'

const radioButtonSize = '18px'

export default (config: {
  props: Pick<RadioButtonProps, 'description'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      wrap: {
        minHeight: '22px',
      },

      input: {
        height: radioButtonSize,
        width: radioButtonSize,
      },

      description: {
        marginBlockStart: '10px',
        marginInlineStart: '30px',
      },

      error: {
        marginBlockStart: props.description ? '6px' : '10px',
        marginInlineStart: '30px',
      },

      label: {
        minHeight: radioButtonSize,
      },

      labelText: {
        ...tokens.fontBodyM,
        minHeight: radioButtonSize,
        paddingInlineStart: '12px',
      },

      radioButtonBorder: {
        borderWidth: '1px',
        height: '18px',
        width: '18px',
      },

      radioButtonFill: {
        background: '#2463d1',
        border: '5px solid #2463d1',
        marginInlineStart: '3px',
      },
    },
  } as const
}
